//------Gigya code for newsletter Page starts------//
var newsletter_header_value = {
  isoLanguage: "en",
  isoCountry: "IN",
  brandCode: "BHA361",
  brandDescription: "Liquid I.V.",
  formID: "7cc1cdba",
  campaignId: "PN007080",
  campaignURL: "https://campaignwizard.unilever.com/campaign-wizard/campaign/7cc1cdba",
  campaignDescription: "Liquid I.V.",
  origin: "https://liquid-iv.co.in/",
  formType: "signUp",
  entity: "PRM2.6",
};
// console.log("gigya_newsletter_header_value: ", newsletter_header_value);

// $(document).ready(function() {
//   $("body").on("click", "#ContactFooter button#Subscribe", function(e) {
//     e.preventDefault();
//     $(".error_msg").text(""); // Clear previous error messages
//     if (validateNewsletterForm()) {
//       console.log("Validation passed!");
//       if (typeof gigya_newsletter_code === "function") {
//         gigya_newsletter_code(newsletter_header_value);
//       } else {
//         console.error("Gigya function is not defined.");
//       }
//     } else {
//       console.log("Validation failed.");
//     }
//   });
// });

// function validateNewsletterForm() {
//   var email = $(".ContactFooterEmail").val();
//   var consentChecked = $("#consent-newsletter-checkbox").is(":checked");
//   if (!email || !consentChecked) {
//     $(".error_msg").text("Fields marked with an asterisk are required.");
//     return false;
//   }
//   return true;
// }

$(document).ready(function() {
  $("body").on("click", "#ContactFooter button#Subscribe", function(e) {
    e.preventDefault();
    $(".error_msg").text(""); // Clear previous error messages
    if (validateNewsletterForm(this)) {
      console.log("Validation passed!");
      if (typeof gigya_newsletter_code === "function") {
        gigya_newsletter_code(newsletter_header_value, this);
      } else {
        console.error("Gigya function is not defined.");
      }
    } else {
      console.log("Validation failed.");
    }
  });
});

function validateNewsletterForm(button) {
  var form = $(button).closest("#ContactFooter");
  var email = form.find(".ContactFooterEmail").val();
  var consentChecked = form.find("#consent-newsletter-checkbox").prop("checked");

  console.log("consentChecked:", consentChecked);

  if (!email || !consentChecked) {
    form.find(".error_msg").text("Fields marked with an asterisk are required.");
    return false;
  }
  return true;
}

function gigya_newsletter_code(newsletter_header_value, button) {
  // var email = $(".ContactFooterEmail").val();
  // var consentChecked = $("#consent-newsletter-checkbox").is(":checked");
  var form = $(button).closest("#ContactFooter");
  var email = form.find(".ContactFooterEmail").val();
  var consentChecked = form.find("#consent-newsletter-checkbox").prop("checked");

  console.log("consentChecked:", consentChecked);

  var optInStatus_value = {
    legalAgeConsent: consentChecked,
    unileverEmailConsent: consentChecked,
    unileverSMSConsent: consentChecked,
  };
  var data_value = JSON.stringify({
    profile: {
      header: newsletter_header_value,
      // consumerIdentity: {
      //   firstName: firstName,
      //   lastName: lastName,
      //   mobileNo: phoneNo,
      // },
      contactDetail: {
        email: email,
      },
      optInStatus: optInStatus_value,
    },
  });
  console.log("gigya_newsletter_data_value: ", data_value);
  var settings = {
    url: "https://forms-sg.unileversolutions.com/v3",
    method: "POST",
    timeout: 0,
    headers: {
      "x-api-key": "77f1e0f0-0118-4437-b208-5118ca844e29",
      "Content-Type": "application/json",
    },
    data: data_value,
  };
  $.ajax(settings).done(function(response) {
    console.log("Pass response: ", response);
    createNewsletterCookie(response);
    $("form#ContactFooter").submit();
    // $("form#ContactFooter button#Subscribe").text("Processing..");
  }).fail(function(response) {
    console.log("Fail response: ", response.responseText);
    var errorObject = JSON.parse(response?.responseText);
    $(".error_msg").text(errorObject.downstreamApiResponse?.Value || "An error occurred. Please try again.");
    // $(".form#ContactFooter button#Subscribe").text("Log In");
  });
}

function createNewsletterCookie(id) {
  console.log("Success:", id);
  const d = new Date();
  d.setTime(d.getTime() + 30 * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = "UnileverId=" + id["UnileverId"] + ";" + expires + ";path=/";
}
//------Gigya code for login Page ends------//